import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';
import { cps } from 'redux-saga/effects';

export function upload(file, channel_id, selectImportOption) {
    let data = new FormData();
    data.append('importFile', file);
    data.append('ChannelID', channel_id)
    data.append('movie', 'movie')
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/itemname/import',
        headers: getApiHeader(),
        dataType: "JSON",
        withCredentials: true,
        data: data,
    }
    return axios(options)
}
export function uploadItemName(fileUpload, channel_id, selectImportOption) {
    let data = new FormData();
    data.append('channelId', channel_id);
    data.append('importOption', selectImportOption)
    data.append('importFile', fileUpload)

    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/itemname/import',
        headers: getApiHeader(),
        dataType: "JSON",
        withCredentials: true,
        data
    }
    return axios(options)
}
export function deleteItem(data) {
    const options = {
        method: 'DELETE',
        url: process.env.REACT_APP_URL + '/api/itemname/delete',
        headers: getApiHeader(),
        dataType: "JSON",
        withCredentials: true,
        data: data,
    }
    return axios(options)
}
export function update(data) {
    const options = {
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/itemname/update',
        headers: getApiHeader(),
        withCredentials: true,
        dataType: "JSON",
        data: data,
    }
    return axios(options)
}
export function exportItemName(channel_id) {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/itemname/export?channelID=' + channel_id,
        headers: getApiHeader(),
        withCredentials: true,
        dataType: "JSON",
    }
    return axios(options)
}

export function getMasterUpdateSetting() {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/itemname/getitemnamesetting',
        headers: getApiHeader(),
        withCredentials: true,
        dataType: "JSON",
    })
}

export function saveMasterUpdateSetting(ItemnameSettingID) {
    return axios({
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/itemname/updateitemnamesetting',
        headers: getApiHeader(),
        withCredentials: true,
        dataType: "JSON",
        data: {
            ItemnameSettingID
        }
    })
}

export function deleteDatabase(channelId) {
    return axios({
        method: 'DELETE',
        url: process.env.REACT_APP_URL + `/api/itemname/deleteall?channelId=${channelId}`,
        headers: getApiHeader(),
        withCredentials: true,
    })
}



// WEBPACK FOOTER //
// ./src/utils/settingMerchant.js